export default __webpack_public_path__ + "static/walrus-404-2c16b594a29daa409a5504c7ec3ebf9e.webp";